export default __webpack_public_path__ + "static/image-c5f91bb1ec15f8084a856203f8b0ceed.png";